export default __webpack_public_path__ + "static/media/header1.8fb5fe7e.png";